import { Box, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { useUserState } from "src/components/UserState";
import SingleSelectionPageComponent from "src/features/SingleSelectionPageComponent";
import { trainwellColor } from "src/theme/themePrimitives";

export const Route = createFileRoute("/_layout/experienceLevel")({
  component: RouteComponent,
});

function RouteComponent() {
  const setSelections = useUserState((state) => state.setSelections);

  return (
    <SingleSelectionPageComponent
      titleText="How experienced are you with strength training?"
      bodyText="This will help us adjust the intensity of your training plan. Beginners are welcome!"
      items={[
        {
          label: (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              Beginner
              <Typography
                sx={{ color: trainwellColor.neutral6 }}
                variant="caption"
              >
                No consistent training in the last 6 months
              </Typography>
            </Box>
          ),
          id: "beginner",
        },
        {
          label: (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              Novice
              <Typography
                sx={{ color: trainwellColor.neutral6 }}
                variant="caption"
              >
                Training consistently for 1-6 months
              </Typography>
            </Box>
          ),
          id: "novice",
        },
        {
          label: (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              Intermediate
              <Typography
                sx={{ color: trainwellColor.neutral6 }}
                variant="caption"
              >
                Training consistently for 6-24 months
              </Typography>
            </Box>
          ),
          id: "intermediate",
        },
        {
          label: (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              Advanced
              <Typography
                sx={{ color: trainwellColor.neutral6 }}
                variant="caption"
              >
                Training consistently for 24+ months
              </Typography>
            </Box>
          ),
          id: "advanced",
        },
      ]}
      onSelectionChange={(selectedItem) => {
        if (selectedItem !== null) {
          setSelections("/experienceLevel", [selectedItem]);
        } else {
          setSelections("/experienceLevel", undefined);
        }
      }}
    />
  );
}
